import React from "react";
import { useTranslation } from "react-i18next";

/**
 * The shell of an invitation acceptance screen.
 *
 * Deliberately the same split layout as login and password reset: this is an
 * authentication surface, not part of the application shell, and it must render
 * for someone who belongs to no organization yet.
 *
 * The side panel defaults to the PLATFORM Owner-provisioning copy, because that
 * is the flow it was written for. A tenant invitation is not an Owner invitation,
 * so `title` and `note` let the tenant acceptance page say what it really is: an
 * invitation for a Търговец or a Мениджър must never be introduced as
 * „Покана за собственик“.
 */
export const InviteShell = ({ title, note, children }) => {
  const { t } = useTranslation();

  return (
    <div className="qw-auth-wrap">
      <div className="qw-auth-side">
        <div>
          <div className="brand">OFFERTRACE</div>
          <div className="head" data-testid="invite-shell-title">
            {title || t("invite.title")}
          </div>
          <div className="sub" data-testid="invite-shell-note">
            {note || t("invite.side_note")}
          </div>
        </div>
        <div style={{ opacity: 0.7, fontSize: 12 }}>© OfferTrace</div>
      </div>
      <div className="qw-auth-panel">
        <div className="qw-auth-form" data-testid="accept-invite-panel">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InviteShell;
